(function () {
  const STORAGE_KEY = 'ls_collection_filter_state';

  function getCollectionPath() {
    const match = window.location.pathname.match(/^(\/collections\/[^\/]+)/);
    return match ? match[1] : null;
  }

  function saveFilterState() {
    const collectionPath = getCollectionPath();
    if (!collectionPath) return;
    const state = {
      path: collectionPath,
      search: window.location.search,
      timestamp: Date.now()
    };
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  }

  function restoreFilterState() {
    const collectionPath = getCollectionPath();
    if (!collectionPath) return;

    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return;

    try {
      const state = JSON.parse(raw);
      // Only restore if same collection, within 30 min, and current URL has no filters
      const isExpired = Date.now() - state.timestamp > 30 * 60 * 1000;
      const isSameCollection = state.path === collectionPath;
      const hasNoCurrentFilters = !window.location.search || window.location.search === '';

      if (isSameCollection && !isExpired && hasNoCurrentFilters && state.search) {
        // Replace URL without reload to restore filter state
        const newUrl = window.location.pathname + state.search;
        window.history.replaceState(null, '', newUrl);
        // Trigger a page reload so Shopify renders the filtered results
        window.location.reload();
      }
    } catch (e) {
      sessionStorage.removeItem(STORAGE_KEY);
    }
  }

  // Save state when shopper clicks a product link from a collection page
  if (getCollectionPath()) {
    restoreFilterState();

    document.addEventListener('click', function (e) {
      const link = e.target.closest('a[href*="/products/"]');
      if (link) {
        saveFilterState();
      }
    });
  }
})();
